import {
  ActionType,
  ChallengesType,
  ChallengeTypeType,
  ErrorTypes,
  LoadingStatusType,
  OperationDetailsType,
} from 'interfaces';
import {
  action,
  createRequestTypes,
  FAILURE,
  REQUEST,
  RequestTypes,
  SUCCESS,
} from 'services/api';

export const WIDGET_POINTS_DETAILS: RequestTypes = createRequestTypes(
  'WIDGET_POINTS_DETAILS',
);
export const WIDGET_GLOBAL_VIEW_CHALLENGES: RequestTypes = createRequestTypes(
  'WIDGET_GLOBAL_VIEW_CHALLENGES',
);
export const SET_WIDGET_STATUS = 'SET_WIDGET_STATUS';
export const INITIALIZE_DETAIL = 'INITIALIZE_DETAIL';

export const widgetPointsDetails = {
  request: ({ widgetId }: { widgetId: string | number }): ActionType =>
    action(WIDGET_POINTS_DETAILS[REQUEST], { widgetId }),
  success: ({
    widgetId,
    data,
  }: {
    widgetId: string | number;
    data: OperationDetailsType;
  }): ActionType => action(WIDGET_POINTS_DETAILS[SUCCESS], { widgetId, data }),
  failure: ({
    widgetId,
    error,
  }: {
    widgetId: string | number;
    error: ErrorTypes;
  }): ActionType => action(WIDGET_POINTS_DETAILS[FAILURE], { widgetId, error }),
};

export const widgetGlobalViewChallenges = {
  request: ({
    widgetId,
    type,
    status,
  }: {
    widgetId: string | number;
    type: ChallengeTypeType;
    status: string;
  }): ActionType =>
    action(WIDGET_GLOBAL_VIEW_CHALLENGES[REQUEST], { widgetId, type, status }),
  success: ({
    widgetId,
    challenges,
  }: {
    widgetId: string | number;
    challenges: ChallengesType[];
  }): ActionType =>
    action(WIDGET_GLOBAL_VIEW_CHALLENGES[SUCCESS], { widgetId, challenges }),
  failure: ({
    widgetId,
    error,
  }: {
    widgetId: string | number;
    error: ErrorTypes;
  }): ActionType =>
    action(WIDGET_GLOBAL_VIEW_CHALLENGES[FAILURE], { widgetId, error }),
};

export const setWidgetStatus = (
  widgetId: string | number,
  status: LoadingStatusType,
): ActionType => action(SET_WIDGET_STATUS, { widgetId, status });

export const initializeDetail = (
  detailType: 'challenges' | 'pointDetail',
  widgetId: string | number,
): ActionType => action(INITIALIZE_DETAIL, { detailType, widgetId });
